import {buildCivLookup, PlanetCivEntry} from "./estimate.ts";
import {useQuery} from "@tanstack/react-query";
import api from "../api.ts";


export default function useCivLevelMap() {

  const planetsQuery = useQuery({
    queryKey: ['planet-civ'],
    queryFn: async () => (await api.get('/data/planets/civ')).data as PlanetCivEntry[],
    staleTime: 1000 * 60 * 10,
  });

  if(planetsQuery.isPending || planetsQuery.isLoading) {
    return {...planetsQuery, data: null};
  }

  return {...planetsQuery, data: buildCivLookup(planetsQuery.data ?? [])}
}
